// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Pager Button Component */
:host(ids-pager-button) {
  display: inline-flex;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-pager/ids-pager-button.scss"],"names":[],"mappings":"AAAA,+BAAA;AACA;EACE,oBAAA;AACF","sourcesContent":["/* Ids Pager Button Component */\n:host(ids-pager-button) {\n  display: inline-flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
